function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1.75,
  y: 1.75,
  width: 13,
  height: 18,
  rx: 1.5,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 7.75,
  y: 4.75,
  width: 13.5,
  height: 17.5,
  rx: 1.5,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14 13h-1.5a2.5 2.5 0 0 0 0 5H14",
  fill: "none"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 13h1.5a2.5 2.5 0 0 1 0 5H16",
  fill: "none"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 13,
  x2: 16,
  y2: 13
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 18,
  x2: 16,
  y2: 18
});

var SvgCopyLink = function SvgCopyLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1 1 21 22",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy-link.d24b076a.svg";
export { ForwardRef as ReactComponent };